module.exports = __webpack_public_path__ + "fonts/Roboto-700-vietnamese55.3860f0d.woff2";